import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, type ButtonProps } from '@mui/material';
import { EditOutlined } from '@mui/icons-material';

export const EditButton: FC<ButtonProps> = ({ children, ...props }) => {
  const { t } = useTranslation();

  return (
    <Button variant="outlined" startIcon={<EditOutlined />} {...props}>
      {children ?? t('edit')}
    </Button>
  );
};
